import { Column } from 'primereact/column';
import { DataTable, SortOrder } from 'primereact/datatable';
import React, { useCallback, useEffect, useState } from 'react';
import searchIcon from 'src/assets/svgs/searchIcon.svg';
import leftArrow from 'src/assets/svgs/leftArrow.svg';
import westImg from 'src/assets/img/westImg.png';
import fsImg from 'src/assets/img/fsImg.png';
import logImg from 'src/assets/img/logImg.png';
import lianiImg from 'src/assets/img/lianiImg.png';
import { TiFlash } from 'react-icons/ti';
import { FaCircleExclamation } from 'react-icons/fa6';
import { convertedHoursMinutes, getRemovetzTime } from 'src/utils/function';
import { Tooltip } from 'flowbite-react';
import { BsDot } from 'react-icons/bs';
import { jobStatus } from 'src/constants/general';

const TopRequestorEmployeeDatatble = ({
    employeeListData,
    modalOpenTopResponsive,
    requestorName,
    employeeId,
    getEmployList,
    jobListData,
    getJobList,
    topRequestorId,
    isJobList,
    setIsjobList,
    isEmployeeListLoading,
}: any) => {
    const [searchInput, setSearchInput] = useState<string>('');
    const [sortField, setSortField] = useState<string>('totalHours');
    const [sortOrder, setSortOrder] = useState<SortOrder>(-1);
    const [selectedEmployee, setSelectedEmployee] = useState(employeeId);
    const onSort = (e: any) => {
        setSortField(e.sortField);
        setSortOrder(e.sortOrder);
    };

    const Getcomp = (row: any) => (
        <div className="flex items-center gap-1">
            <img className="w-6 h-6 rounded-full" src={row.companyName === 'West' ? westImg : row.companyName === 'Log' ? logImg : row.companyName === 'Liani' ? lianiImg : fsImg} alt="img" />
            <div className="text-black text-xs font-medium font-['Satoshi Variable'] uppercase">{row.companyName}</div>
        </div>
    );
    const Getjobtype = (row: any) => (
        <div className="flex items-center">
            <div className="flex items-center gap-0 relative">
                {row.isAsap ? (
                    <span className="w-5 h-5 rounded-full bg-red-50 text-red500 flex justify-center items-center mr-1 absolute left-[-25px]">
                        <TiFlash />
                    </span>
                ) : (
                    ''
                )}
                {row.isMandatory ? (
                    <span className={`iconresponsive w-5 h-5 rounded-full bg-white text-blue-800 flex justify-center items-center mr-1 absolute ${row.isAsap ? 'left-[-50px]' : 'left-[-25px]'}`}>
                        <FaCircleExclamation size={30} />
                    </span>
                ) : (
                    ''
                )}
            </div>
            <div className="text-black text-xs font-medium font-['Satoshi Variable'] uppercase">{row.jobType}</div>
        </div>
    );
    const GetStartDate = (row: any) => getRemovetzTime(row.startDate, 'MMM. DD, YY');

    const GetEndDate = (row: any) => {
        if (row.endDate) {
            return getRemovetzTime(row.endDate, 'MMM. DD, YY');
        } else {
            return (
                <div className="">
                    <p className="px-5">-</p>
                </div>
            );
        }
    };
    const Getassignemply = (row: any) => {
        const employee = () => (
            <div>
                {row.employeeList.map((data: any, index: number) => (
                    <p className="truncate" key={index}>{`${data.name} ${data.surname}`}</p>
                ))}
            </div>
        );

        return row?.employeeList?.length === 1 ? (
            <p className="truncate">{`${row.employeeList[0].name} ${row.employeeList[0].surname}`}</p>
        ) : (
            <div className="flex">
                <p className="truncate me-[6px]">{`${row.employeeList[0].name} ${row.employeeList[0].surname}..`}</p>
                <Tooltip className="bg-black text-white" content={<>{employee()}</>}>
                    <div className="w-4 h-4 px-2 pt-0.5 pb-1 bg-indigo-500 rounded-2xl flex-col justify-center items-center gap-2 inline-flex">
                        <div className="text-white text-xs font-medium font-['Satoshi Variable']">{row?.employeeList?.length}</div>
                    </div>
                </Tooltip>
            </div>
        );
    };
    const Getstatus = (row: any) => {
        const statusColors: any = {
            [jobStatus.complete]: 'bg-Green20 text-Green80',
            [jobStatus.cancel]: 'bg-purpleLight text-purple80',
            [jobStatus.fail]: 'bg-red20 text-red500',
            [jobStatus.inprogress]: 'bg-yellow20 text-yellow80',
            [jobStatus.invoiced]: 'bg-secondary20 text-secondary',
        };

        const isColor = statusColors[row.status] || '';
        return (
            <div className={`h-6 pe-2 min-w-24 py-1 ${isColor} rounded-lg justify-center items-center inline-flex`}>
                <div>
                    <BsDot size={18} />
                </div>
                <div className={`text-xs font-medium`}>{row.status}</div>
            </div>
        );
    };
    const getTotalHours = (row: any) => <span>{convertedHoursMinutes(row.totalHours, ':')}</span>;
    const debounce = (func: any, delay: any) => {
        let timeoutId: any;
        return (...args: any) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => func(...args), delay);
        };
    };
    const handleSearch = useCallback(
        debounce((searchTerm: any) => {
            getEmployList(topRequestorId, requestorName, searchTerm);
        }, 500),
        [],
    );
    const handleChange = (e: any) => {
        setSearchInput(e.target.value);
        handleSearch(e.target.value);
    };

    return isJobList ? (
        <div className="pt-4">
            <div className="text-center text-zinc-800 text-lg font-medium font-['Satoshi Variable']">
                <div className="flex gap-1  w-16 p-1 absolute top-3 left-2  cursor-pointer items-center" onClick={() => setIsjobList(false)}>
                    <img src={leftArrow} className="w-4 cursor-pointer" alt="back icon" />
                    <span>Back</span>
                </div>
                <div className=" grid grid-cols-2 text-left mt-2 ">
                    <span>Employee Name: {selectedEmployee && employeeListData.find((item: any) => item.employeeId === selectedEmployee).full_name}</span>
                    <span>Employee Job List </span>
                </div>
            </div>
            <div className={`${modalOpenTopResponsive === 'Top Requestor' ? 'h-[calc(100vh-150px)]' : ''} scrollbar-hide overflow-y-auto`}>
                <DataTable value={jobListData} tableClassName="logdatatable jobdatatable" emptyMessage="No Job Record Found" className="" sortField={sortField} sortOrder={sortOrder} onSort={onSort}>
                    <Column field="comp" header="Comp." body={Getcomp}></Column>
                    <Column field="jobtype" header="Job type" body={Getjobtype}></Column>
                    <Column field="jobConfirmation" header="Job ID"></Column>
                    <Column field="requestorName" header="Requestor Name"></Column>
                    <Column field="startdate" header="Start Date" body={GetStartDate}></Column>
                    <Column field="enddate" header="End Date" body={GetEndDate}></Column>
                    <Column field="departmentName" header="Department"></Column>
                    <Column field="totalHours" header="Job Hours" body={getTotalHours} sortable></Column>
                    <Column field="status" header="Status" body={Getstatus}></Column>
                </DataTable>
            </div>
        </div>
    ) : (
        <>
            <div className="pt-6">
                <div className="text-center text-zinc-800 text-lg font-medium font-['Satoshi Variable'] flex justify-between">
                    <span>Requestor Name: {requestorName}</span>
                    <span>Top Employees</span>
                    <div>
                        <div className="w-[300px] relative">
                            <input
                                className={`w-full h-8 px-5 py-1 pr-5 bg-white focus-visible:outline-none focus:border focus:border-primary rounded-3xl border border-gray40 placeholder:text-gray50`}
                                placeholder="Search"
                                value={searchInput}
                                onChange={handleChange}
                            />

                            <img className="w-5 h-5 absolute right-3 top-2" src={searchIcon} alt="searchicon" />
                        </div>
                    </div>
                </div>
                <div className={`${modalOpenTopResponsive === 'Top Requestor' ? 'h-[calc(100vh-150px)]' : ''} scrollbar-hide overflow-y-auto min-w-[1146px] `}>
                    <DataTable
                        value={employeeListData}
                        tableClassName="logdatatable "
                        emptyMessage="No Job Record Found"
                        className=""
                        onRowClick={(e) => {
                            employeeId = e.data.employeeId;
                            setSelectedEmployee(employeeId);
                            getJobList(topRequestorId, employeeId);
                            setIsjobList(true);
                        }}
                        loading={isEmployeeListLoading}
                    >
                        <Column field="full_name" header="Employee Name"></Column>
                        <Column field="total_hours" header="Total hours" body={(row) => convertedHoursMinutes(row.total_hours, ':')}></Column>
                    </DataTable>
                </div>
            </div>
        </>
    );
};
export default TopRequestorEmployeeDatatble;
